// Would prefer all the contexts in a single folder.

import React, { createContext, useReducer } from 'react';

const bookmarksState = {
  datasetId: undefined,
  // Add all the merge and single dataset related filters, sorts and other stuff here.
};

export const BookmarksContext = createContext(bookmarksState);

const BookmarksReducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE_DATASETID':
      return { ...bookmarksState, datasetId: action.datasetId };
    case 'RESET':
      return bookmarksState;
    default:
      return bookmarksState;
  }
};

const BookmarksProvider = ({ children }) => {
  const [state, dispatch] = useReducer(BookmarksReducer, bookmarksState);
  return <BookmarksContext.Provider value={[state, dispatch]}>{children}</BookmarksContext.Provider>;
};

export default BookmarksProvider;
